import './index.css';
import { jsx } from 'react/jsx-runtime';
import { FileView } from './FileView.js';
import { useFilePreview } from './useFilePreview.js';
import { getFileType } from './utils.js';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-avatar';
import '@hh.ru/magritte-ui-divider';
import '@hh.ru/magritte-ui-icon/icon';
import '@hh.ru/magritte-ui-loader';
import '@hh.ru/magritte-ui-spacing';
import './FileName.js';
import 'classnames';
import 'react';

var styles = {"item":"magritte-item___vVDG-_3-2-17"};

const FileViewWithPreview = ({ loadedFile, ...otherProps }) => {
    const uploadType = getFileType(loadedFile.data.type);
    const preview = useFilePreview({ loadedFile, isImageType: uploadType === 'image' });
    return (jsx("div", { className: styles.item, children: jsx(FileView, { uploadType: uploadType, loadedFile: loadedFile, preview: preview, ...otherProps }) }));
};

export { FileViewWithPreview };
//# sourceMappingURL=FileViewWithPreview.js.map
